module.exports = __webpack_public_path__ + "img/eagleEyeLogo.10fc0e10.png";